<template>
      <div class="exams-main">
        <div class="hasCategory ">
             <div class="exams-panel">
                <div class="exams-panel-body">
                       <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-right  flex align-cen">
                                 <div class="regulaOption flex align-cen">
                                    <el-select v-model="value"  clearable placeholder="题目分类"
                                    @change="getList"
                                    >
                                        <el-option
                                        v-for="item in option"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="regulaOption1">
                                    <el-input
                                    placeholder="题目名称"
                                    v-model="input"
                                    clearable>
                                    </el-input>
                                </div>
                                   <div class="table-toolbar-left flex align-cen" style="margin-left:20px">
                                <div class="now-exam btnexam btnactive" @click="getList">搜索</div>
                                <div class="log-exam btnexam" @click="reset">重置</div>
                            </div>
                            </div>
                        </div>
                        <div class="wrongDiv">
                            <div class="chat-flex flex">
                                <div class="student-detailds-chart">
                                    <div class="student-detailds-chart-head">
                                        <span>答题次数：{{Tnum}}</span>
                                    </div>
                          <div class="summaryOfTestPie">
                                    <div class="exam-pr-pie">
                                    <lineChart :option="LineChartOption" :barID="'lineID'"></lineChart>
                                    </div>
                                </div>
                                </div>
                                  <div class="student-detailds-chart">
                                    <div class="student-detailds-chart-head">
                                        <span>错题率：{{TwrongRate}}%</span>
                                    </div>
                          <div class="summaryOfTestPie">
                                    <div class="exam-pr-pie">
                                        <PieChart :option="PieChartOption" :pieID="'quPie'"></PieChart>
                                    </div>
                                </div>
                                </div>
                            </div>
                             <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 错题记录
                            </div>
                            </div>
                               <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                        <el-table-column label="题目名称" align="center">
                             <template slot-scope="scope">
                        <div class="flex align-cen justify-content-cen"> 
                            <div  v-html="scope.row.title" class="publictitline2" :class="scope.row.type == 9 ? 'clozeClass' : ''"></div>
                            <AudioTem :audioSrc="scope.row.audio" v-if="scope.row.audio"></AudioTem>
                            </div> 
                             </template>
                      </el-table-column>
                      <el-table-column  label="题型" align="center">
                            <template slot-scope="scope">
                            <p>{{$util.getTopicType(scope.row.type)}}</p>
                            </template>
                        </el-table-column>
                         <el-table-column prop="num" label="错误次数" align="center">
                         </el-table-column>
                            <el-table-column
                                label="操作"
                                align="center"
                                width="150"       
                                >
                      <template slot-scope="scope">
                        <el-button type="text" style="color:red" @click="openWrongDet(scope.row)">查看详情</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                        </div>
                        <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                        </div>
                </div>
             </div>
        </div>
      </div>
</template>
<script>
import {getAllTopicClassify,countByDay,wqRate,wrongPage} from "@/api/enterprise/index"   //题目分类、每日答题次数、错题记录
import lineChart from "@/components/lineTemolate/index.vue"; //折线图图组件
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件\
import PieChart from "@/components/pieTemolate/index.vue"; //饼图组件
import mycomponents from "../../utils/compoments.js"
export default {
    name:'wrongBook',
    components:{
      lineChart,
      paginaTion,
      PieChart,
      AudioTem: mycomponents.components.PublicAudio
    },
    data() {
        return {
            Tnum:0,
            TwrongRate:0,
            businessInfo:{},
            option:[],
            value:'',
            input:'',
            LineChartOption:{},
             PieChartOption:{},
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            itemList:[],
        }
    },
    created () {
           if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
        this.getClass()
        this.getCountByDay()
        this.getRate()
        this.wrongPage()
    },
    methods: {
          emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.wrongPage()
      },
      // 打开详情
      openWrongDet(data){
         this.$router.push({
            name:'wrongDetailIndex',
            query:{
                id:data.id,
                businessId:this.businessInfo.id
            }
            })
      },
        // 获取错题记录
        wrongPage(){
            let params = {
                businessId:this.businessInfo.id,
                classifyId:this.value,
                title:this.input,
                size:this.PageSize,
                current:this.currentPage,
            }
            wrongPage(params)
            .then(res =>{
             this.itemList = res.data.records
               this.totalCount= res.data.total
            })
        },
        // 获取错误率
          getRate(){
            wqRate({businessId:this.businessInfo.id,classifyId:this.value,title:this.input})
            .then(res =>{
              this.TwrongRate = res.data.wrongRate
              this.Tnum = res.data.answerNum
                   let srdata = [
                        { value: Number(res.data.rightRate), name: '正确',num:Number(res.data.rightRate) },
                        { value: Number(res.data.wrongRate), name: '错误',num:Number(res.data.wrongRate)  },
                      ]
             this.PieChartOption = {
                title: {
                  text: '错题率',
                  left: 'center'
                },
                tooltip: {
                  trigger: 'item',
                  formatter:function(params){
                    var str = '';
                    str = `${params.data.name}</br>比例：${params.data.value}%`
                     return str
                  }
                },
                legend: {
                orient: 'horizontal',
                left: 'auto'
              },
              color: ['#FF6969','#699DFF'],
                series: [
                    {
                      name: '错题率',
                      type: 'pie',
                      radius: '50%',
                      data: srdata,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
              }
            })
          },
        // 获取答题次数
        getCountByDay(){
            countByDay({businessId:this.businessInfo.id,classifyId:this.value,title:this.input})
            .then(res =>{
               let xData1 = [],
                   sData1 = []
                      for (let key in res.data) {
                xData1.push(res.data[key].TIME)
                sData1.push({
                name:res.data[key].time,
                value:Number(res.data[key].num),
                 itemStyle: {
                    color:  key == 0 ? '#FF6969' : '#699DFF'
                  }
              })
               }
               this.LineChartOption = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `考生在${params[0].name}号这一天的答题次数${params[0].value}`
                     return str
                  }
                },
                   grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                  series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
            })
        },
        // 获取题目分类
            getClass(){
            getAllTopicClassify({name:'',businessId:this.businessInfo.id})
            .then(res =>{
                this.option = res.data
            })
        },
        getList(){
          this.currentPage = 1
            this.getCountByDay()
        this.getRate()
        this.wrongPage()
        },
        reset(){
          this.currentPage = 1
          this.value = ''
          this.input = ''
           this.getCountByDay()
        this.getRate()
        this.wrongPage()
        }
    },
}
</script>
<style lang="scss" scoped>
.wrongDiv{
    padding: 0 16px;
}
.chat-flex{
    justify-content: space-between;
    .student-detailds-chart{
        background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    flex: 0 0 50%;
    max-width: 49.5%;
    }
    .student-detailds-chart-head{
        padding: 9px 16px;
    border-bottom: 1px solid #e6e6e6;
    span{
    font-weight: 700;
    font-size: 18px;
    color: #333;
}
    }

}
  .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
        ::v-deep{
  .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>